var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboCloseSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10124 7.00023L13.8837 1.21774C14.1328 0.976475 13.9538 0.556213 13.6113 0.556213H12.514C12.4128 0.556213 12.3116 0.595127 12.2416 0.672953L7.01167 5.90288L1.76618 0.672953C1.69614 0.602909 1.59497 0.556213 1.49379 0.556213H0.38866C0.0462246 0.556213 -0.132776 0.976475 0.116268 1.21774L5.89876 7.00023L0.116268 12.7827C-0.132776 13.0318 0.0462246 13.4442 0.38866 13.4442H1.48601C1.58718 13.4442 1.68836 13.4053 1.7584 13.3275L6.98833 8.09758L12.2182 13.3275C12.2883 13.3975 12.3895 13.4442 12.4906 13.4442H13.588C13.9382 13.4442 14.1094 13.024 13.8604 12.7827L8.07789 7.00023H8.10124Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboCloseSmall);
export default __webpack_public_path__ + "static/media/FBOCloseSmall.68a93a6c7b827e1203fdfa020858114c.svg";
export { ForwardRef as ReactComponent };